import { render } from "./DosenMahasiswa.vue?vue&type=template&id=319e15b6&scoped=true"
import script from "./DosenMahasiswa.vue?vue&type=script&lang=js"
export * from "./DosenMahasiswa.vue?vue&type=script&lang=js"

import "./DosenMahasiswa.vue?vue&type=style&index=0&id=319e15b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-319e15b6"]])

export default __exports__